import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/deploydog': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M382.2 136H433.9V375.6H382.2V354.9C362.4 379.7 329.4 379 308.4 369.6 282.2 357.9 264.1 331.5 264.1 297.8 264.1 268 278.9 239.9 307.4 227 327.6 217.9 360.1 216.4 382.2 239.9V136zM317.5 297.8C317.5 316 331.1 331.3 350.7 331.3 370.5 331.3 383.9 314.9 383.9 298.4 383.9 281.3 370.2 265.2 350.7 265.2 331.1 265.2 317.5 281.6 317.5 297.8zM188.5 136H240.2V375.6H188.5V354.9C168.7 379.7 135.7 379 114.7 369.6 88.5 357.9 70.4 331.5 70.4 297.8 70.4 268 85.2 239.9 113.7 227 133.9 217.9 166.4 216.4 188.5 239.9V136zM123.8 297.8C123.8 316 137.4 331.3 157 331.3 176.8 331.3 190.2 314.9 190.2 298.4 190.2 281.3 176.5 265.2 157 265.2 137.3 265.2 123.8 281.6 123.8 297.8zM448 96C465.5 96 480 110.4 480 128V384C480 401.5 465.6 416 448 416H64C46.5 416 32 401.6 32 384V128C32 110.5 46.4 96 64 96H448M448 64H64C28.8 64 0 92.8 0 128V384C0 419.2 28.8 448 64 448H448C483.2 448 512 419.2 512 384V128C512 92.8 483.2 64 448 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/deploydog.js
// module id = TwPf
// module chunks = 144